import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Questions } from './components/Questions';
import { TarotFrame } from './components/TarotFrame';
import { Proposal } from './components/Proposal';
import { UrgentCTA } from './components/UrgentCTA';
import { Services } from './components/Services';
import { Testimonials } from './components/Testimonials';
import { VideoCall } from './components/VideoCall';
import { ContactFooter } from './components/ContactFooter';
import { TawkToWidget } from './components/TawkToWidget';
import { GoogleTagManager } from './components/GoogleTagManager';
export function App() {
  return <div className="min-h-screen w-full bg-ink font-sans text-white" data-id="element-0" data-mp="31cjog1g2xp1w">
      <GoogleTagManager data-id="element-1" data-mp="2wifh3h2wjf0a" />
      <Header data-id="element-2" data-mp="2wi5nljineppu" />
      <main data-id="element-3" data-mp="28u5y0mx2p5cu">
        <Hero data-id="element-4" data-mp="28tw4ipctkg2e" />
        <Questions data-id="element-5" data-mp="28te21azkd5m1" />
        <TarotFrame data-id="element-6" data-mp="28suw6sn6u7od" />
        <Proposal data-id="element-7" data-mp="28sbad0uf2z52" />
        <UrgentCTA data-id="element-8" data-mp="23vcm2yxfpmes" />
        <Services data-id="element-9" data-mp="23w4fq47h1a2f" />
        <Testimonials data-id="element-10" data-mp="23ujkecdc1n3i" />
        <VideoCall data-id="element-11" data-mp="23v2tr4ox335x" />
      </main>
      <ContactFooter data-id="element-12" data-mp="3ik7gwiph6frp" />
      <TawkToWidget data-id="element-13" data-mp="3ikqyfyb7r257" />
    </div>;
}